import { Box, Typography } from "@mui/material"
import React, { useContext, useMemo } from "react"
import { customPalette } from "../../theme"
import { DepartmentContext } from "../core/context/DepartmentContext"
import { formatToFrench } from "../core/services/date-service"

interface IProps {
  createdByUser: string | undefined
  department: string | undefined
  lastModifiedDate: Date | undefined
  backgroundColor?: string
  isForNavbar?: boolean
}

export function CreatedByDisplayer({
  createdByUser,
  department,
  lastModifiedDate,
  backgroundColor,
  isForNavbar,
}: Readonly<IProps>): React.JSX.Element {
  const { findDepartmentById } = useContext(DepartmentContext)

  const departmentName = useMemo(() => {
    if (department) {
      const departement = findDepartmentById(department)
      return departement ? departement.departmentName : ""
    } else {
      return ""
    }
  }, [findDepartmentById, department])

  function getBackgroundColor(): string {
    if (isForNavbar) {
      return customPalette.dark1
    }

    if (backgroundColor) {
      return backgroundColor
    }
    return customPalette.white
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      width="fit-content"
      borderRadius={3}
      px={1}
      sx={{ background: getBackgroundColor }}>
      <Typography fontWeight={400} fontSize={10} lineHeight="14px" sx={{ color: customPalette.lightBlue2 }}>
        {createdByUser && `Crée par ${createdByUser ?? ""} · `} {departmentName && `${departmentName} · `}
        {` Mise à jour le ${formatToFrench(lastModifiedDate)}`}
      </Typography>
    </Box>
  )
}
